import { render, staticRenderFns } from "./WidgetModal.vue?vue&type=template&id=104ce85e&scoped=true&"
import script from "./WidgetModal.vue?vue&type=script&lang=js&"
export * from "./WidgetModal.vue?vue&type=script&lang=js&"
import style0 from "./WidgetModal.vue?vue&type=style&index=0&id=104ce85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104ce85e",
  null
  
)

export default component.exports